import React from 'react';
import { Link } from 'react-router-dom';

const Logo = ({ size = 'md', className = '' }) => {
  // Size variations
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-16 h-16',
    xl: 'w-24 h-24'
  };

  const textSizeClasses = {
    sm: 'text-lg',
    md: 'text-2xl',
    lg: 'text-3xl',
    xl: 'text-4xl'
  };

  return (
    <Link to="/" className={`flex items-center space-x-3 ${className}`}>
      <div className={`${sizeClasses[size]} rounded-full overflow-hidden bg-white shadow-lg border-2 border-gray-200 flex-shrink-0`}>
        <img
          src="/logo.ico"
          alt="Zest Logo"
          className="w-full h-full object-cover"
        />
      </div>
      <span className={`${textSizeClasses[size]} font-bold`}>
        Zest
      </span>
    </Link>
  );
};

export default Logo;
